<template>
<div>
    <div class="container_full margin_60_35">
        
        <div class="container" v-if="action=='send-code'">
            
            <div class="row justify-content-md-center">
                <div class="box_general col-12 col-md-5 ">
                    <div class="text-center mb-2">
                        <img src="@/assets/img/logo.png"/>
                    </div>
                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Recuperar contraseña</h2>
                    </div>
                    
                    <div class="row ">
                        <div class="col-lg-12">
                            <div class="form-group mb-0">
                                <label>Ingresá tu email para recuperar la contraseña</label>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <input  
                                    type="text"
                                    class="form-control" 
                                    placeholder="Email" 
                                    v-model="form.email" 
                                    :class="{'is-invalid':validationErrors['general']}"
                                    >
                                <div class="invalid-feedback">{{validationErrors['general']}}</div>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col">
                            <button class="btn btn-sm pull-right btn-success" @click="forgotPasswordSend()">Continuar</button>
                            <router-link tag="button" class="btn btn-sm pull-left" to="/login">Volver</router-link>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        <div class="container" v-if="action=='code-sended'">
            <div class="row justify-content-md-center">
                <div class="box_general col-12 col-md-5 ">
                    <div class="text-center mb-2">
                        <img src="@/assets/img/logo.png"/>
                    </div>
                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Recuperar contraseña</h2>
                    </div>
                    
                    <div class="row ">
                        <div class="col-lg-12">
                            <p>Te hemos enviado un correo con las instrucciones para reestablecer tu contraseña.</p>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        
        
        <div class="container" v-if="action=='reset-password'">
            <div class="row justify-content-md-center">
                <div class="box_general col-12 col-md-5">
                    <div class="text-center mb-2">
                        <img src="@/assets/img/logo.png"/>
                    </div>
                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Establecer nueva contraseña</h2>
                    </div>
                    
                    <div class="row ">
                        
                        <div class="col-lg-12">
                            <FormulateForm
                                v-if="!loading"
                                ref="form"
                                v-model="form"
                                @submit="resetPasswordSend" 
                                >
                                

                                <FormulateInput
                                    label="Contraseña"
                                    type="password"
                                    name="password"
                                    :showMeter="true"
                                    placeholder="Contraseña"
                                    validation-name="Contraseña"
                                    validation="required"
                                />

                                <FormulateInput
                                    name="password_confirm"
                                    type="password"
                                    label="Confirmar contraseña"
                                    placeholder="Confirmar contraseña"
                                    validation="required|confirm"
                                    validation-name="Confirmar contraseña"
                                />
                            </FormulateForm>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col">
                            <button class="btn btn-sm pull-right btn-success" @click="resetPasswordSend">Cambiar contraseña</button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

        <div class="container" v-if="action=='password-updated'">
            <div class="row justify-content-md-center">
                <div class="box_general col-12 col-md-5 ">
                    <div class="text-center mb-2">
                        <img src="@/assets/img/logo.png"/>
                    </div>
                    <div class="header_box">
                        <h2><i class="pe-7s-id"></i>Contraseña actualizada</h2>
                    </div>
                    
                    <div class="row ">
                        <div class="col-lg-12">
                            <p>Su contraseña ha sido actualizada correctamente.<br>Ahora puede volver a ingresar al sistema con su nueva contraseña.</p>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col">
                            <router-link tag="a" class="btn btn-sm pull-right btn-success" to="/login">Ingresar</router-link>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>

	</div>

</div>
</template>

<script>
import gql from 'graphql-tag'

import Password from 'vue-password-strength-meter'

export default {
    name: 'ForgotPassword',
    metaInfo: {
		title: 'Olvidé mi contraseña',
	},
    components: {
        Password
    },
    data() {
        return {
            form:{
                passwordNew:'',
            },
            action:'send-code',
            hasChanges:false,
            loading:false,
            validationErrors:{},
            passwordStrength:0,
            showPassword:false,
            passwordFeedback:null
        }
    },
    beforeMount(){
        if( this.$route.query.code ){
            this.action = 'reset-password';
        }
    },
    methods:{
        showPasswordFeedback ({suggestions, warning}) {
            this.passwordFeedback = {suggestions, warning};  
        },
        passwordScore (score) {
            this.passwordStrength = score;
        },

        forgotPasswordSend(){
            var error=false;
            this.validationErrors = {};
            
            if( !this.form.email ){
                error=true;
                this.validationErrors['general'] = 'Ingrese su email';
            }

            if( !this.loading && !error){
                this.loading=true;

                this.$apollo.mutate({
                    mutation: gql`mutation ( $email:String! ){
                        pharmacyForgotPassword( email: $email)
                    }`,
                    variables: {
                        email: this.form.email,
                    }
                })
                .then((data) => {
                    if(data.data.pharmacyForgotPassword){
                        this.action = 'code-sended'
                    }
                    this.loading=false;
                    this.hasChanges = false;
                    this.form = {};
                })
                .catch(error => {
                    this.errors = this.parseGQLErrors(error)
                    this.loading=false;
                })
            }
        },

        resetPasswordSend(){
            var error=false;
            
            if( !this.loading ){
                this.loading=true;
                var dataInput = {
                    code: this.$route.query.code,
                    password: this.form.password,
                };
                console.log('dataInput',dataInput);
                
                this.$apollo.mutate({
                    mutation: gql`mutation ( $code:String!, $password:String! ){
                        pharmacyUpdateForgottenPassword( code: $code, password: $password)
                    }`,
                    variables: dataInput
                })
                .then((data) => {
                    console.log(data)
                    if(data.data.pharmacyUpdateForgottenPassword){
                        this.action='password-updated'
                    }
                    this.loading=false;
                    this.hasChanges = false;
                    
                })
                .catch(error => {
                    this.errors = this.parseGQLErrors(error)
                    this.loading=false;
                })
            }
        },
        
    },
    beforeRouteLeave (to, from , next) {
        if(this.hasChanges ){
            const answer = window.confirm('¿De verdad quieres irte? Usted tiene cambios sin guardar!')
            if (answer) {
                next()
            } else {
                next(false)
            }
        }else{
            next()
        }
    }
    
}
</script>

<style scoped>
.container_full{
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}
</style>
